export class ServerAddressLoadError extends Error {
  constructor() {
    super('Server address load error');
  }
}

export class PermissionsError extends Error {
  constructor(
    public permissions: string[]
  ) {
    super(`Permission error - ${permissions.join(', ')}`);
  }
}

export class LanguageNotSupportedError extends Error {
  constructor() {
    super('Language not supported error');
  }
}